__turbopack_context__.v({
  "avatar-row": "social-proof-desktop-module-scss-module__53RFuG__avatar-row",
  "media-image": "social-proof-desktop-module-scss-module__53RFuG__media-image",
  "media-video": "social-proof-desktop-module-scss-module__53RFuG__media-video",
  "panel": "social-proof-desktop-module-scss-module__53RFuG__panel",
  "panel-media": "social-proof-desktop-module-scss-module__53RFuG__panel-media",
  "panel-reversed": "social-proof-desktop-module-scss-module__53RFuG__panel-reversed",
  "panel-testimonial-full": "social-proof-desktop-module-scss-module__53RFuG__panel-testimonial-full",
  "panel-testimonial-split": "social-proof-desktop-module-scss-module__53RFuG__panel-testimonial-split",
  "panel-video": "social-proof-desktop-module-scss-module__53RFuG__panel-video",
  "social-proof-header": "social-proof-desktop-module-scss-module__53RFuG__social-proof-header",
  "social-proof-inner": "social-proof-desktop-module-scss-module__53RFuG__social-proof-inner",
  "social-proof-scroll-area": "social-proof-desktop-module-scss-module__53RFuG__social-proof-scroll-area",
  "social-proof-sticky-container": "social-proof-desktop-module-scss-module__53RFuG__social-proof-sticky-container",
  "social-proof-title": "social-proof-desktop-module-scss-module__53RFuG__social-proof-title",
  "social-proof-wrapper": "social-proof-desktop-module-scss-module__53RFuG__social-proof-wrapper",
});
